var map = {
	"./mod_hw_days_2021-2040_hist_rcp45_rcp85_allpct.nc": 69290,
	"./mod_hw_days_2041-2060_hist_rcp45_rcp85_allpct.nc": 835364,
	"./mod_hw_days_2061-2080_hist_rcp45_rcp85_allpct.nc": 406272,
	"./mod_hw_days_2081-2100_hist_rcp45_rcp85_allpct.nc": 200680,
	"./mod_hw_events_2021-2040_hist_rcp45_rcp85_allpct.nc": 393480,
	"./mod_hw_events_2041-2060_hist_rcp45_rcp85_allpct.nc": 809132,
	"./mod_hw_events_2061-2080_hist_rcp45_rcp85_allpct.nc": 293712,
	"./mod_hw_events_2081-2100_hist_rcp45_rcp85_allpct.nc": 895188,
	"./mod_hw_meanmag_2021-2040_hist_rcp45_rcp85_allpct.nc": 449948,
	"./mod_hw_meanmag_2041-2060_hist_rcp45_rcp85_allpct.nc": 775504,
	"./mod_hw_meanmag_2061-2080_hist_rcp45_rcp85_allpct.nc": 519196,
	"./mod_hw_meanmag_2081-2100_hist_rcp45_rcp85_allpct.nc": 185896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62940;